import React, { useEffect, useState } from 'react';
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from './firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase';
import { format } from 'date-fns';

export default function EmbajadorasAdmin() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('aprobadas');
  const [resetStatus, setResetStatus] = useState({}); // { uid: 'sending' | 'sent' | 'error' }

  async function load() {
    setLoading(true);
    const snap = await getDocs(collection(db, 'users'));
    const rows = [];
    snap.forEach(d => rows.push({ id: d.id, ...d.data() }));
    setUsers(rows.filter(u => u.role !== 'admin'));
    setLoading(false);
  }

  useEffect(() => { load(); }, []);

  async function approve(uid) {
    await updateDoc(doc(db, 'users', uid), { approved: true });
    await load();
  }

  async function revoke(uid) {
    if (!window.confirm('¿Revocar acceso de esta embajadora?')) return;
    await updateDoc(doc(db, 'users', uid), { approved: false });
    await load();
  }

  async function sendReset(user) {
    if (!window.confirm(`¿Enviar email de restablecimiento de contraseña a ${user.name} (${user.email})?`)) return;
    setResetStatus(s => ({ ...s, [user.id]: 'sending' }));
    try {
      await sendPasswordResetEmail(auth, user.email);
      setResetStatus(s => ({ ...s, [user.id]: 'sent' }));
      // Limpiar estado después de 4 segundos
      setTimeout(() => setResetStatus(s => ({ ...s, [user.id]: null })), 4000);
    } catch (err) {
      console.error(err);
      setResetStatus(s => ({ ...s, [user.id]: 'error' }));
      setTimeout(() => setResetStatus(s => ({ ...s, [user.id]: null })), 4000);
    }
  }

  function getResetBtn(user) {
    const status = resetStatus[user.id];
    if (status === 'sending') return <button className="btn btn-ghost btn-sm" disabled>Enviando...</button>;
    if (status === 'sent') return <button className="btn btn-ghost btn-sm" disabled style={{ color: 'var(--forest)' }}>✓ Enviado</button>;
    if (status === 'error') return <button className="btn btn-danger btn-sm" disabled>Error</button>;
    return (
      <button className="btn btn-ghost btn-sm" onClick={() => sendReset(user)} title="Enviar email de recuperación">
        🔑 Blanquear
      </button>
    );
  }

  const displayed = users.filter(u => tab === 'aprobadas' ? u.approved : !u.approved);

  return (
    <div>
      <div className="page-header">
        <h1>Embajadoras</h1>
        <p>Gestión de usuarias del sistema</p>
      </div>
      <div className="page-body">

        {/* Aviso sobre el blanqueo */}
        <div className="alert-item alert-info" style={{ marginBottom: 20 }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 13 }}>¿Cómo funciona el blanqueo de contraseña?</div>
            <div style={{ fontSize: 12, color: 'var(--text-light)', marginTop: 2 }}>
              Al hacer click en <strong>Blanquear</strong>, la embajadora recibe un email con un enlace para crear una nueva contraseña. El enlace expira en 1 hora. Si no le llega, revisá que el email esté bien escrito y pedile que revise spam.
            </div>
          </div>
        </div>

        <div className="tabs">
          <button className={`tab${tab === 'pendientes' ? ' active' : ''}`} onClick={() => setTab('pendientes')}>
            Pendientes {users.filter(u => !u.approved).length > 0 && `(${users.filter(u => !u.approved).length})`}
          </button>
          <button className={`tab${tab === 'aprobadas' ? ' active' : ''}`} onClick={() => setTab('aprobadas')}>
            Aprobadas ({users.filter(u => u.approved).length})
          </button>
        </div>

        {tab === 'pendientes' && displayed.length > 0 && (
          <div className="alert-item alert-warning" style={{ marginBottom: 16 }}>
            ⚡ Hay {displayed.length} embajadora{displayed.length > 1 ? 's' : ''} esperando aprobación.
          </div>
        )}

        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <div className="table-wrap">
            {loading ? <div className="spinner" /> : (
              <table>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Email</th>
                    <th>Teléfono</th>
                    <th>Zona</th>
                    <th>Registro</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {displayed.length === 0 ? (
                    <tr><td colSpan={7} style={{ textAlign: 'center', color: 'var(--text-light)', padding: 40 }}>Sin usuarias</td></tr>
                  ) : displayed.map(u => (
                    <tr key={u.id}>
                      <td style={{ fontWeight: 600 }}>{u.name}</td>
                      <td style={{ color: 'var(--text-light)' }}>{u.email}</td>
                      <td>{u.phone || '-'}</td>
                      <td>{u.zone || '-'}</td>
                      <td style={{ color: 'var(--text-light)' }}>
                        {u.createdAt ? format(u.createdAt.toDate ? u.createdAt.toDate() : new Date(u.createdAt), 'dd/MM/yy') : '-'}
                      </td>
                      <td>
                        <span className={`badge ${u.approved ? 'badge-green' : 'badge-yellow'}`}>
                          {u.approved ? 'Aprobada' : 'Pendiente'}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                          {/* Blanqueo de contraseña — siempre disponible */}
                          {getResetBtn(u)}

                          {/* Aprobar / Revocar */}
                          {!u.approved ? (
                            <button className="btn btn-primary btn-sm" onClick={() => approve(u.id)}>
                              Aprobar
                            </button>
                          ) : (
                            <button className="btn btn-danger btn-sm" onClick={() => revoke(u.id)}>
                              Revocar
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}